(function () {
  'use strict';
  if (window.PrintmoDesignerJourney) return;
  var ready = false;
  var started = false;
  var tagReady = false;
  var waitingForTag = false;
  var queue = [];
  var cartPending = false;
  var pendingKey = 'printmo:designer-entry:v1';
  var points = ['navigation', 'homepage', 'product', 'designer_landing', 'other'];
  var actions = ['add_text', 'add_image', 'add_shape', 'edit_content', 'transform', 'duplicate', 'delete'];

  function publicPath(path) {
    return path === '/' || /^\/(pages|products|collections)\/[a-z0-9][a-z0-9_-]*\/?$/i.test(path)
      ? path.slice(0, 160) : 'other';
  }

  function tag() {
    if (typeof window.gtag === 'function') window.gtag.apply(window, arguments);
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(arguments);
    }
  }

  function flush() {
    tagReady = true;
    var pending = queue;
    queue = [];
    pending.forEach(function (item) {
      try { tag('event', item[0], item[1]); } catch (_) {}
    });
  }

  function send(name, parameters) {
    try {
      var params = Object.assign({ send_to: 'G-5X1Z8CQDJE', transport_type: 'beacon' }, parameters);
      if (tagReady) tag('event', name, params);
      else {
        if (queue.length >= 20) return false;
        queue.push([name, params]);
        if (!waitingForTag) {
          waitingForTag = true;
          // Wait for the existing tag API; do not store or copy its identifier.
          tag('get', 'G-5X1Z8CQDJE', 'client_id', flush);
        }
      }
      return true;
    } catch (_) { return false; }
  }

  window.PrintmoDesignerJourney = {
    ready: function () {
      if (ready) return;
      ready = send('designer_ready', { entry_page: publicPath(window.location.pathname) });
    },
    designStarted: function (action) {
      if (!ready || started || actions.indexOf(action) === -1) return;
      started = send('design_started', { design_action: action });
    }
  };

  // Reuse the cart lifecycle; never mirror its raw payload or ecommerce items.
  window.addEventListener('pm:add-to-cart-telemetry', function (event) {
    if (!/^\/pages\/designer-studio\/?$/.test(window.location.pathname)) return;
    try {
      var detail = event.detail;
      if (!detail || ['start', 'success', 'failure'].indexOf(detail.type) === -1) return;
      var params = { cart_outcome: detail.type };
      if (detail.type === 'start') {
        if (cartPending) return;
        cartPending = true;
      } else {
        if (!cartPending) return;
        cartPending = false;
        if (typeof detail.durationMs === 'number' && isFinite(detail.durationMs)
          && detail.durationMs >= 0 && detail.durationMs <= 3600000) {
          params.cart_duration_ms = Math.round(detail.durationMs);
        }
        if (detail.type === 'failure') {
          var reasons = ['timeout', 'network_error', 'rate_limited', 'validation_error', 'export_incomplete'];
          params.cart_error_category = reasons.indexOf(detail.reason) === -1 ? 'unknown' : detail.reason;
        }
      }
      send('designer_add_to_cart_telemetry', params);
    } catch (_) {}
  });

  // Consume before sending, so refresh and duplicate loaders cannot replay an entry.
  if (/^\/pages\/designer-studio\/?$/.test(window.location.pathname)) {
    try {
      var raw = window.sessionStorage.getItem(pendingKey);
      window.sessionStorage.removeItem(pendingKey);
      var entry = raw && JSON.parse(raw);
      var age = entry && Date.now() - entry.created_at;
      if (entry && typeof entry.created_at === 'number' && age >= 0 && age <= 120000
        && typeof entry.entry_page === 'string' && publicPath(entry.entry_page) === entry.entry_page
        && points.indexOf(entry.entry_point) !== -1) {
        send('designer_entry_click', { entry_page: entry.entry_page, entry_point: entry.entry_point });
      }
    } catch (_) {}
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('a[href], [data-designer-cta]') : null;
    if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    try {
      var url = new URL(target.getAttribute('href') || '/pages/designer-studio', window.location.origin);
      if (url.origin !== window.location.origin || !/^\/pages\/designer-studio\/?$/.test(url.pathname)) return;
      var page = window.location.pathname;
      var point = target.closest('header, nav, [data-header]') ? 'navigation'
        : page === '/' ? 'homepage'
        : page.indexOf('/products/') === 0 ? 'product'
        : page === '/pages/designer-studio-landing' ? 'designer_landing' : 'other';
      var parameters = { entry_page: publicPath(page), entry_point: point };
      // Modified/new-tab actions leave the source document alive for normal dispatch.
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
        || target.getAttribute('target') === '_blank' || target.hasAttribute('download')) {
        send('designer_entry_click', parameters);
        return;
      }
      try {
        window.sessionStorage.setItem(pendingKey, JSON.stringify(Object.assign({ created_at: Date.now() }, parameters)));
      } catch (_) { send('designer_entry_click', parameters); }
    } catch (_) {}
  }, true);
})();
